"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.86,23.18l-6-6a10.3,10.3,0,1,0-.68.68l6,6a.48.48,0,0,0,.68-.68ZM1,10.27a9.3,9.3,0,1,1,9.3,9.3A9.32,9.32,0,0,1,1,10.27Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5.09",
    y: "5.06",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.79",
    y: "5.06",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.48",
    y: "5.06",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5.09",
    y: "8.79",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.79",
    y: "8.79",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.48",
    y: "8.79",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5.09",
    y: "12.52",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.79",
    y: "12.52",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.48",
    y: "12.52",
    width: "2.96",
    height: "2.96",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }));
};

exports["default"] = _default;